import { faces } from "@/mocks/gossip";

export default function NewFaces() {
  return (
    <section id="faces" className="border-b border-foreground-950/10 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        {/* header */}
        <div className="mb-8 flex flex-col justify-between gap-4 md:mb-10 md:flex-row md:items-end">
          <div>
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-add-circle-fill" /> 新涉事者聚焦
            </div>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">本周新面孔档案</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每一位首次进入公众讨论的近期人物，我们都为其建一份可回溯的背景档案：因何被卷入、立场如何迁移、目前缺少哪一段上下文。
            </p>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-600">
            <span className="rounded-full border border-foreground-950/15 bg-background-50 px-3 py-1.5 whitespace-nowrap">本周收录 <b className="text-primary-700">6</b> 位</span>
            <span className="hidden rounded-full border border-foreground-950/15 bg-background-50 px-3 py-1.5 whitespace-nowrap sm:inline-flex">平均每日新增 2 位</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {faces.map((f) => (
            <article
              key={f.name}
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-950/10 bg-background-50 transition-colors hover:border-primary-400/50"
            >
              <div className="flex gap-4 p-4 md:p-5">
                <div className="h-20 w-16 shrink-0 overflow-hidden rounded-md md:h-24 md:w-[4.5rem]">
                  <img src={f.image} alt={`${f.name} 背景档案封面`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-baseline justify-between gap-2">
                    <h3 className="font-heading text-lg font-black text-foreground-950">{f.name}</h3>
                    <span className="shrink-0 whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">热度 {f.heat}</span>
                  </div>
                  <p className="mt-0.5 truncate text-xs text-foreground-600 md:text-sm">{f.role}</p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {f.tags.map((t) => (
                      <span key={t} className="whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">{t}</span>
                    ))}
                  </div>
                </div>
              </div>

              <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-700 md:px-5">{f.intro}</p>

              <div className="mt-auto border-t border-foreground-950/5 px-4 py-3 md:px-5">
                <div className="mb-1.5 flex items-center justify-between text-[11px] text-foreground-500">
                  <span>跟踪进度</span>
                  <span className="inline-flex items-center gap-1 text-primary-700"><i className="ri-focus-3-line" /> {f.watch}</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-primary-500" style={{ width: `${f.heat}%` }} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}